<template>
<div v-if="expose && calendar">
  <navigation></navigation>
  <expose-calendar-appointment v-if="calendar.appointment" :expose="expose" :appointment="calendar.appointment"></expose-calendar-appointment>
  <expose-calendar-scheduler v-else :expose="expose" :days="calendar.days"></expose-calendar-scheduler>
</div>
</template>

<script>
import Navigation from "./Navigation";
import ExposeCalendarScheduler from "./ExposeCalendarScheduler";
import ExposeCalendarAppointment from "./ExposeCalendarAppointment";

export default {
  name: "ExposeCalendarContainer",

  components: {
    Navigation,
    ExposeCalendarScheduler,
    ExposeCalendarAppointment
  },

  data() {
    return {
      days: null,
      appointment: null
    };
  },

  computed: {
    expose() {
      const exposeId = this.$route.params.exposeId;
      return this.$store.state.expose.expose[exposeId];
    },

    calendar() {
      const exposeId = this.$route.params.exposeId;
      return this.$store.state.expose.calendar[exposeId];
    }
  },

  created() {
    this.$store.dispatch("expose/loadAll");

    const exposeId = this.$route.params.exposeId;
    this.$store.dispatch("expose/loadCalendar", exposeId);
  }
};
</script>
